import { render, staticRenderFns } from "./BusinessTab.vue?vue&type=template&id=5b23f690&scoped=true"
import script from "./BusinessTab.vue?vue&type=script&lang=js"
export * from "./BusinessTab.vue?vue&type=script&lang=js"
import style0 from "./BusinessTab.vue?vue&type=style&index=0&id=5b23f690&prod&lang=scss"
import style1 from "./BusinessTab.vue?vue&type=style&index=1&id=5b23f690&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b23f690",
  null
  
)

export default component.exports